<template>
  <div>
    <!-- Banner -->
    <v-banner color="secondary" outlined>
      <h2>نظرات و پیشنهادات</h2>
      <v-breadcrumbs :items="items">
        <template v-slot:divider>
          <v-icon>mdi-chevron-left</v-icon>
        </template>
      </v-breadcrumbs>
    </v-banner>
    <!-- Rating -->
    <v-col cols="12" md="12" sm="12">
      <v-card class="rounded" elevation="0" :height="commnets ? 'auto' : '20'">
        <!-- <v-list-item-content>
          <v-list-item-title class="mr-4" style="margin: 0px; font-weight: 800">
            نظرات و پیشنهادات
          </v-list-item-title>
        </v-list-item-content> -->
        <v-row class="my-3 mx-3" v-for="(ranker, i) in rank" :key="i">
          <v-col
            class="my-3 mx-3 align-self-center"
            align="center"
            cols="12"
            md="2"
            sm="2"
          >
            <v-label
              class="point"
              style="font-weight: 800 !important; font-size: 25px !important"
              >{{ ranker.star.toFixed(1) }}</v-label
            >
            <strong> از 5</strong>
            <v-rating
              size="17"
              empty-icon="mdi-star-outline"
              full-icon="mdi-star"
              half-icon="mdi-star-half-full"
              half-increments
              background-color="orange lighten-3"
              color="orange"
              :value="ranker.star"
              readonly
            >
            </v-rating
          ></v-col>
          <!-- Rating progress -->
          <v-col cols="12" md="9" sm="9" class="mt-4">
            <v-row v-for="(rankstar, i) in ranker.stars" :key="i">
              <v-col class="d-flex pa-0">
                <p class="countRate ml-2">
                  {{ i + 1 }}
                </p>
                <v-progress-linear
                  color="light-green"
                  height="10"
                  :value="(rankstar * 100) / ranker.votes"
                  rounded
                ></v-progress-linear>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <!-- Comments -->
        <v-row class="mt-2 mx-1">
          <v-col
            v-for="(item, i) in commnets.data"
            :key="i"
            cols="12"
            md="4"
            sm="6"
            class="d-flex"
            style="padding: 1px"
          >
            <v-card
              hover
              link
              class="rounded-lg my-1 mx-1 mb-6 pa-3"
              width="400"
              min-height="134"
            >
              <v-card-title
                style="font-size: 12px; letter-spacing: 0; font-weight: 200"
                class="pa-3"
                align="start"
              >
                <picture>
                  <source type="image/webp" :srcset="item.image" />
                  <v-avatar rounded size="50">
                    <img :src="item.image" :alt="item.user" />
                  </v-avatar>
                </picture>
                <p class="mt-4 mr-3">
                  {{ item.user }}
                  <br />
                  {{ item.created_at }}
                </p>
                <v-spacer></v-spacer>
                <p class="d-flex">
                  <v-label class="mt-1">
                    {{ item.star + ".0" }}
                  </v-label>
                  <v-rating
                    size="17"
                    background-color="orange lighten-3"
                    color="orange"
                    length="1"
                    :value="item.star"
                    full-icon="mdi-star"
                    readonly
                  >
                  </v-rating>
                </p>
              </v-card-title>
              <v-card-subtitle class="caption">
                {{
                  item.content
                    ? item.content
                    : "توضیحاتی برای این نظر اضافه نشده است"
                }}
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          text: "خانه",
          disabled: false,
          href: "/",
        },
        {
          text: "نظرات و پیشنهادات",
          disabled: false,
          href: "comments",
        },
      ],
      commnets: [],
      rank: [],
      overlay: false,
      State: false,
      url: process.env.SITEURL,
      location: window.document.location.host.replace("www.", ""),
    };
  },
  metaInfo() {
    return {
      title: "نامیا",
      titleTemplate: "%s | نظرات و پیشنهادات",
    };
  },
  head: {
    link: [
      {
        rel: "canonical",
        href: "https://namya.ir/",
        id: "canonical",
      },
    ],
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "نامیا نمایشگاه مجازی کسب و کارهاست ، با نامیا کسب و کارت رو آنلاین کن ،نامیا اولین شبکه اجتماعی کسب و کارهاست ایجاد وب سایت اختصاصی ،کارت ویزیت دیجیتال",
      },
      {
        name: "keywords",
        content:
          "نامیا،کارت ویزیت دیجیتال،وب سایت اختصاصی ،شبکه اجتماعی ،کارت ویزیت آنلاین ،باشگاه مشتریان ،درخواست ها ،نوبت دهی آرایشگاه ،کارواش",
      },
      { name: "twitter:card", content: "summary" },
      {
        name: "twitter:site",
        content: "",
      },
      {
        name: "twitter:title",
        content: "نامیا | اولین نمایشگاه مجازی کسب و کارها ",
      },
      {
        name: "twitter:description",
        content:
          "نامیا نمایشگاه مجازی کسب و کارهاست ، با نامیا کسب و کارت رو آنلاین کن ،نامیا اولین شبکه اجتماعی کسب و کارهاست ایجاد وب سایت اختصاصی ،کارت ویزیت دیجیتال",
      },
      // Your twitter handle, if you have one.
      { name: "twitter:creator", content: "" },
      {
        name: "twitter:image:src",
        content: "https://namya.ir/repository/businesses/300_300/48/14010828114138-542.png",
      },

      // Google / Schema.org markup:
      {
        itemprop: "name",
        content: "نامیا | اولین نمایشگاه مجازی کسب و کارها ",
      },
      {
        itemprop: "description",
        content:
          "نامیا نمایشگاه مجازی کسب و کارهاست ، با نامیا کسب و کارت رو آنلاین کن ،نامیا اولین شبکه اجتماعی کسب و کارهاست ایجاد وب سایت اختصاصی ،کارت ویزیت دیجیتال",
      },
      {
        itemprop: "image",
        content: "https://namya.ir/repository/businesses/300_300/48/14010828114138-542.png",
      },
    ],
  },
  created() {
    this.booths();
  },
  methods: {
    async booths() {
      var self = this;
      let response = await self.axios.get(
        "https://namya.ir/api/v1/businesses/booths/48"
      );
      // console.log(self.$route.params.name);
      self.customers = response.data;
      this.title = this.customers.data.name;
      this.keywords = this.customers.data.tags.map((tags) => `${tags.name}`);
      this.description = this.customers.data.aboutus;
      this.tags = this.customers.data.tags;
      this.getcommnets();
      this.getrank();
    },
    async getcommnets() {
      var self = this;
      // localStorage.setItem("ID", self.$route.params.ID);
      let response = await self.axios.get(
        "https://namya.ir/api/v1/businesses/booth/48/comments"
      );
      // console.log(response.data);
      self.commnets = response.data;
    },
    async getrank() {
      var self = this;
      let response = await self.axios.get(
        "https://namya.ir/api/v1/businesses/booths/48"

      );
      // console.log(response.data);
      self.rank = response.data;
    },
    // async getComment() {
    //   let response = await this.axios
    //     .get(
    //       "https://namya.ir/api/v1/businesses/booth/" +
    //         localStorage.getItem("ID") +
    //         "/comments"
    //     )
    //     .then((response) => {
    //       this.comments = response.data.data;
    //     });
    // },

    // async getVote() {
    //   let response = await this.axios
    //     .get(
    //       "https://namya.ir/api/v1/businesses/booths/" +
    //         localStorage.getItem("ID")
    //     )
    //     .then((response) => {
    //       var star = response.data.data.star.toFixed(1);
    //       this.star = Number(star);
    //       this.stars = response.data.data.stars;
    //       this.votes = response.data.data.votes;
    //     });
    // },
  },
};
</script>

<style scoped>
.v-banner__text {
  line-height: inherit;
}

.v-application .my-10 {
  margin-bottom: 20px !important;
}

.v-application .ma-8 {
  margin-left: 10px !important;
}

.v-application .text-h6 {
  font-family: IRANSansX, sans-serif !important;
  font-size: 0.9rem !important;
}

* >>> .v-rating .v-icon {
  padding: 0.25rem !important;
}

.v-card__subtitle,
.v-card__text {
  font-size: 0.9rem;
}

.v-rating .v-icon {
  padding: 3px;
}
.v-card__title {
  line-height: 1.5rem;
}
.v-label {
  font-size: 25px;
  font-weight: 800;
}
</style>

<style>
.point {
  font-family: IRANSansX, sans-serif !important;
  font-weight: 800 !important;
  font-size: 25px !important;
}

.countRate {
  font-family: IRANSansX, sans-serif !important;
  font-weight: 500 !important;
  margin-top: -6px !important;
}
.v-application .caption {
  font-family: IRANSansX, sans-serif !important;
  font-weight: 200 !important;
  letter-spacing: 0 !important;
  line-height: 1.25rem;
}
</style>
